export default __webpack_public_path__ + "static/media/header.60a92a1d.svg";